import swal from 'sweetalert'
import { privateAPI } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'
import * as generalTypes from '../types/generalTypes'

export const getLoyaltyOffers = () => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.get(`/loyalty/get-vendor-loyalty-offers`)
      if (res) {
        let resp = decrypt(res.data)
        dispatch({
          type: generalTypes.LOYALTY_OFFERS,
          payload: resp.result,
        })
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}

export const toggleLoyaltyOffers = (id, status) => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.post(`/loyalty/toggle-vendor-loyalty-offer`, {
        data: {
          loyaltyOffersId: id,
          status,
        },
      })
      if (res) {
        let resp = decrypt(res.data)
        dispatch(getLoyaltyOffers())
        swal('', resp.message, 'success')
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}

export const addUserLoyalty = (payload) => {
  return async () => {
    try {
      const res = await privateAPI.post(`/loyalty/add-userloyalty`, {
        data: { payload },
      })
      if (res) {
        let resp = decrypt(res.data)
        swal('', resp.message, 'success')
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}

export const createLoyaltyOffer = (payload) => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.post(`/loyalty/create-vendor-loyalty-offer`, {
        data: { payload },
      })
      if (res) {
        let resp = decrypt(res.data)
        dispatch(getLoyaltyOffers())
        swal('', resp.message, 'success')
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}

export const updateLoyaltyOffer = (payload) => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.post(`/loyalty/update-vendor-loyalty-offer`, {
        data: { payload },
      })
      if (res) {
        let resp = decrypt(res.data)
        dispatch(getLoyaltyOffers())
        swal('', resp.message, 'success')
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}

export const getLoyaltyLevels = () => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.get(`/loyalty/get-vendor-loyalty-levels`)
      if (res) {
        let resp = decrypt(res.data)
        dispatch({
          type: generalTypes.LOYALTY_LEVELS,
          payload: resp.result,
        })
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}
export const createLoyaltyLevel = (payload) => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.post(`/loyalty/create-vendor-loyalty-level`, {
        data: { payload },
      })
      if (res) {
        let resp = decrypt(res.data)
        dispatch(getLoyaltyLevels())
        swal('', resp.message, 'success')
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}

export const updateLoyaltyLevel = (payload) => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.post(`/loyalty/update-vendor-loyalty-level`, {
        data: { payload },
      })
      if (res) {
        let resp = decrypt(res.data)
        dispatch(getLoyaltyLevels())
        swal('', resp.message, 'success')
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}
export const toggleLoyaltyLevels = (id, status) => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.post(`/loyalty/toggle-vendor-loyalty-level`, {
        data: {
          loyaltyLevelsId: id,
          status,
        },
      })
      if (res) {
        let resp = decrypt(res.data)
        dispatch(getLoyaltyLevels())
        swal('', resp.message, 'success')
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}
